import request from "@/utils/request";

export function getInvoiceList(data) {
  // console.log(data)
  return request({
    url: "/mgr/invoices/queryInvoicesList",
    method: "post",
    data,
  });
}

export function getInvoiceById(data) {
  // console.log(data)
  return request({
    url: "/mgr/invoices/queryInvoicesDetailList",
    method: "post",
    data,
  });
}

export function getInvoicesItem(data) {
  return request({
    url: "/mgr/invoices/queryInvoicesItemsList",
    method: "post",
    data,
  });
}

export function getInvoicesHistoryAndEvents(data) {
  return request({
    url: "/mgr/invoices/queryHistoryAndEvents",
    method: "post",
    data,
  });
}

export function getInvoicesBillingAndDelivery(data) {
  return request({
    url: "/mgr/invoices/queryInvoicesBillingAndDeliveryList",
    method: "post",
    data,
  });
}

export function getInvoicesPayment(data) {
  return request({
    url: "/mgr/invoices/queryPaymentList",
    method: "post",
    data,
  });
}

export function getItemsFromOrders(data) {
  return request({
    url: "/mgr/invoices/searchItems",
    method: "get",
    params: data,
  });
}

export function saveInvoicesInfo(data) {
  return request({
    url: "/mgr/invoices/saveInvoicesInfo",
    method: "post",
    data,
  });
}

export function saveInvoicePayment(data) {
  return request({
    url: "/mgr/invoices/savePayment",
    method: "post",
    data,
  });
}

export function printInvoicePage(id) {
  return request({
    url: `/mgr/invoices/pdf/invoice/${id}`,
    method: "get",
  });
}

export function printPickingSlip(id) {
  return request({
    url: `/mgr/invoices/pdf/pickingSlip/${id}`,
    method: "get",
  });
}

export function printCreditNotesPreview(id) {
  return request({
    url: `/mgr/invoices/pdf/creditPreview/${id}`,
    method: "get",
  });
}
export function convertQuoteToInvoice(data) {
  return request({
    url: `/mgr/invoices/convertQuoteToInvoice`,
    method: "post",
    data,
  });
}

export function cloneQuote(data) {
  return request({
    url: `/mgr/invoices/cloneQuote`,
    method: "post",
    data,
  });
}

export function cancelQuote(data) {
  return request({
    url: `/mgr/invoices/cancelQuote`,
    method: "post",
    data,
  });
}

export function finalizedInvoice(data) {
  return request({
    url: `/mgr/invoices/finalizedInvoice`,
    method: "post",
    data,
  });
}

export function addGeneralNotes(data) {
  return request({
    url: `/mgr/invoices/addNotesAndInfo`,
    method: "post",
    data,
  });
}

export function editGeneralNotes(data) {
  return request({
    url: `/mgr/invoices/editNotesAndInfo`,
    method: "put",
    data,
  });
}

export function addInvoiceNotes(data) {
  return request({
    url: `/mgr/invoices/addInvoiceNotes`,
    method: "post",
    data,
  });
}

export function editInvoiceNotes(data) {
  return request({
    url: `/mgr/invoices/editInvoiceNotes`,
    method: "put",
    data,
  });
}

export function getPartDetail(data, signal) {
  return request({
    url: "/mgr/invoices/queryParts",
    method: "get",
    params: data,
    signal,
  });
}

export function saveCreditNotes(data) {
  return request({
    url: `/mgr/invoices/saveCreditNotes`,
    method: "post",
    data,
  });
}
export function queryPaymentList(data) {
  return request({
    url: "/mgr/invoices/queryPaymentList",
    method: "get",
    params: data,
  });
}
export function deleteCreditAndPayment(data) {
  return request({
    url: "/mgr/invoices/deleteCreditAndPayment",
    method: "delete",
    params: data,
  });
}
export function deleteInvoiceItem(invoiceItemId) {
  return request({
    url: `/mgr/invoices/deleteInvoiceItem/${invoiceItemId}`,
    method: "delete",
  });
}
export function checkItemSoldOrNot(tagNoList) {
  return request({
    url: `/mgr/invoices/checkItemSoldOrNot/${tagNoList}`,
    method: "post",
  });
}

export function reOpenInvoice(invoiceID) {
  return request({
    url: `/mgr/invoices/reOpenedJob/${invoiceID}`,
    method: "post",
  });
}

export function getItemStatusAndImage(id) {
  return request({
    url: `/mgr/invoices/getImage/${id}`,
    method: "get",
  });
}

export function confirmQuote(id) {
  return request({
    url: `/mgr/invoices/acceptQuote/${id}`,
    method: "put",
  });
}

export function getAssignedJobHistory(id) {
  return request({
    url: `/mgr/history/getHistoryList/${id}`,
    method: "get",
  });
}

export function getInvoiceItemImages(data) {
  return request({
    url: "/mgr/invoices/getItemImages",
    method: "get",
    params: data,
  });
}

export function getAssignedDispatchHistory(id) {
  return request({
    url: `/mgr/history/getDispatchHistoryList/${id}`,
    method: "get",
  });
}

export function getSignatureAndPhoto(invoiceID) {
  return request({
    url: `/mobile/delivery/getSignatureAndPhoto/${invoiceID}`,
    method: "get",
  });
}

export function sendEmailDispatchPhoto(data) {
  return request({
    url: `/mgr/invoices/sendDispatchMail`,
    method: "post",
    data,
  });
}

export function reSendJob(invoiceID, data) {
  return request({
    url: `/mgr/invoices/resend/${invoiceID}`,
    method: "put",
    data,
  });
}

export function changePrintPricing({ invoiceID, isPrintPrice }) {
  return request({
    url: `/mgr/invoices/printPrice/${invoiceID}`,
    method: "put",
    params: { isPrintPrice },
  });
}

export function getShippingInfo(orderId) {
  return request({
    url: `/mgr/shipping/getShipping/${orderId}`,
    method: "post",
  });
}

export function getConsignmentStatus(consignmentNumber) {
  return request({
    url: `/mgr/shipping/consignmentStatus`,
    method: "post",
    params: { consignmentNumber },
  });
}

export function saveShipping(orderId) {
  return request({
    url: `/mgr/shipping/saveShipping/${orderId}`,
    method: "post",
  });
}

export function printShipping(barcode) {
  return request({
    url: `/mgr/shipping/print`,
    method: "post",
    data: { Barcode: String(barcode), IncludeLabelsPdf: true },
  });
}
